import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["sublist__item", { 'keyboard-selected': _ctx.selected }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick(_ctx.item)))
  }, _toDisplayString(_ctx.item.label), 3))
}